import(/* webpackMode: "eager", webpackExports: ["SubNavigationTabs"] */ "/app/apps/pickleball/src/modules/players/v2/navigation/SubNavigationTabs.tsx");
